module.exports = __webpack_public_path__ + "p1pl4me.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/32.jpg
// module id = 560
// module chunks = 1